module.exports = __webpack_public_path__ + "img/hr-boiler-E-light.1f434999.png";